"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var breakpoints = {
  mobile: 0,
  tablet: 700,
  laptop: 1024,
  desktop: 1200
};
var _default = breakpoints;
exports.default = _default;